export const mainTableData = (data, index, type) => {
  let columnDataArray = [];
  let mainSeriesData = [];

  let crossTabs = data.main_db.crosstabs;
  let questions = data.main_db.crosstab_questions;

  if (crossTabs[index]) {
    let columnLength = questions[index].answers.length;
    let columnSum = [];
    let seriesTemp = [];
    let totalsSum = 0,
      totalPercentSum = 0,
      errorPercentSum = 0,
      underLimitSum = 0,
      upperLimitSum = 0;

    for (let i = 0; i < columnLength; i++) {
      let count = crossTabs[index].row_totals[i];
      let totalPercent = (crossTabs[index].row_total_percents[i] * 100).toFixed(
        1
      );
      let errorPercent = (crossTabs[index].row_errors[i] * 100).toFixed(1);
      let underLimit = Number(totalPercent) - Number(errorPercent);
      let upperLimit = Number(totalPercent) + Number(errorPercent);
      var range =
        (underLimit > 0 ? underLimit.toFixed(1) : 0) +
        " ~ " +
        (upperLimit > 0 ? upperLimit.toFixed(1) : 0);
      totalsSum = Number(totalsSum) + Number(crossTabs[index].row_totals[i]);
      totalPercentSum = Number(totalPercentSum) + Number(totalPercent);
      errorPercentSum = Number(errorPercentSum) + Number(errorPercent);
      underLimitSum =
        Number(underLimitSum) +
        Number(underLimit > 0 ? underLimit.toFixed(1) : 0);
      upperLimitSum =
        Number(underLimitSum) +
        Number(upperLimit > 0 ? upperLimit.toFixed(1) : 0);
      columnDataArray[i] = [
        crossTabs[index].row_totals[i],
        totalPercent,
        errorPercent,
        crossTabs[index].sum_signifs_array[i],
        range,
      ];

      // series data
      let goalArray = [];
      goalArray.push({
        name: "MAX",
        value: upperLimit > 0 ? Number(upperLimit.toFixed(1)) : 0,
        strokeWidth: 15,
        strokeHeight: 0,
        strokeLineCap: "round",
        strokeColor: "#555",
      });
      goalArray.push({
        name: "MIN",
        value: underLimit > 0 ? Number(underLimit.toFixed(1)) : 0,
        strokeWidth: 15,
        strokeHeight: 0,
        strokeLineCap: "round",
        strokeColor: "#555",
      });

      let series = {
        x: questions[index].answers[i].desc,
        y: Number(totalPercent).toFixed(1),
        count: Number(count).toFixed(0),
        error: Number(errorPercent).toFixed(1),
        goals: goalArray,
      };

      seriesTemp.push(series);
    }

    mainSeriesData = [{ data: seriesTemp }];
    columnSum = [
      totalsSum,
      totalPercentSum.toFixed(1),
      (crossTabs[index].total_error * 100).toFixed(1),
      "",
      underLimitSum.toFixed(1) + "~" + upperLimitSum.toFixed(1),
    ];
    columnDataArray.push(columnSum);
  }
  return { columnDataArray, mainSeriesData };
};
